import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type { Option } from 'modules/core/components/Popover/Content'
import i18n from 'modules/core/lib/i18n'

import Actions from './Actions'

interface Props {
  fileName: string
  options: Option[]
  uploading?: boolean
}

const Item = ({ options, fileName, uploading }: Props) => {
  return (
    <Box
      width="full"
      flexDirection="row"
      padding="s16"
      alignItems="center"
      justifyContent="spaceBetween"
    >
      <Box gap="s8" flexDirection="row">
        <Icon.Medium icon="duplicate" />
        <Text.Normal color="grey800">
          {uploading ? `${fileName} (${i18n.t('tasks.labels.uploading')})` : fileName}
        </Text.Normal>
      </Box>
      {!uploading && <Actions options={options} />}
    </Box>
  )
}

export default observer(Item)
